import queryString from 'query-string';
import pathToRegexpOrig from 'path-to-regexp';

function pathToRegexp(path) {
  let keys = [];
  let re = pathToRegexpOrig(path, keys);
  return {re, keys, path};
}

export function getMatch(location, viewPatterns) {
  viewPatterns = viewPatterns.map(o => pathToRegexp(o))
  for(let wr of viewPatterns) {
    let match = wr.re.exec(location.pathname);
    if(match) {
      let mUrl = match[0];
      let mParams = match.slice(1);
      let params = {};
      for(let i = 0; i < mParams.length; i++) {
        let paramKey = wr.keys[i].name;
        let paramValue = mParams[i];
        params[paramKey] = paramValue;
      }
      let query = queryString.parse(location.search);
      return {
        params,
        query,
        path: wr.path,
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/routingUtils.js